import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const MODULE_VERSION_CONSUMERS_TABLE_STORAGE_KEY = "moduleVersionConsumersTableStorageKey";
export const MODULE_VERSION_CONSUMERS_TABLE_FILTERS_STORAGE_KEY =
  "moduleVersionConsumersTableFiltersStorageKey";

export enum MODULE_VERSION_CONSUMERS_COLUMN_ID {
  NAME = "NAME",
  SPACE = "SPACE",
}

const MAX_CELL_WIDTH = 600;

export const MODULE_VERSION_CONSUMERS_TABLE_COLUMNS_CONFIG: Record<
  MODULE_VERSION_CONSUMERS_COLUMN_ID,
  TableColumnMeta
> = {
  [MODULE_VERSION_CONSUMERS_COLUMN_ID.NAME]: {
    id: MODULE_VERSION_CONSUMERS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 400,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    // Settings are hidden on this table, so there is no chrome to hide, pin, or move against.
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
  [MODULE_VERSION_CONSUMERS_COLUMN_ID.SPACE]: {
    id: MODULE_VERSION_CONSUMERS_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 120,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
};

export const SORT_CONFIG: Record<MODULE_VERSION_CONSUMERS_COLUMN_ID, string> = {
  [MODULE_VERSION_CONSUMERS_COLUMN_ID.NAME]: "name",
  [MODULE_VERSION_CONSUMERS_COLUMN_ID.SPACE]: "space",
};

/** Matches `useTableSort` / URL: sort key is the encoded column field (`SORT_CONFIG` value), not the column id. */
export const INITIAL_SORT_OPTION = SORT_CONFIG[MODULE_VERSION_CONSUMERS_COLUMN_ID.NAME];
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Asc;

export const NO_STICKY_RIGHT = () => false;
